























































































import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import type {
  IdParams,
  ParamsApi,
  Tramo,
  DataMasiva,
} from './models/BajasComerciales.model';

const { AgGridVue } = require('ag-grid-vue');

import {
  AgGridEvent,
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
} from 'ag-grid-community';

import { fetchBajasComerciales, DashboardResponse } from './fetchBajasComerciales';

import Confirmation from '@/components/Confirmation.vue';
import PopUpGenerateReports from './PopUpGeneratedReports.vue';


@Component({
  components: {
    GridComponent: AgGridVue,
    Confirmation,
    PopUpGenerateReports,
  },
})
export default class BajasComercialesAsignarTramo extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) objParam!: ParamsApi;
  @Prop({ default: false, required: false }) bajaFinalizada: boolean;
  @Prop({ required: false }) dataList: any[];

  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  gridEvent: AgGridEvent = null;
  columnApi: ColumnApi = null;
  editado: boolean = false;
  columnDefs: ColDef[] = [];
  serverSide: any = null;

  msgReport: string = '';
  showPopUpReport: boolean = false;

  step: string = 'general';
  dialog: boolean = true;

  tramo: Tramo = {} as Tramo;
  tramos: Tramo[] = [];
  TramosCounter: number = 0;
  //dataList: any[] = [];

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  dialogConfirmacionClose: boolean = false;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 4,
      cacheBlockSize: 4,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Cliente', id: 'cliente' },
      { field: 'Nombre Baja', id: 'nombre_baja' },
      { field: 'Fecha Creación', id: 'fecha_alta' },
      { field: 'Cantidad de Equipos', id: 'cantidad_equipos' },
      { field: 'Cantidad Perifericos', id: 'cantidad_perifericos' },
      { field: 'Total', id: 'total' },
      { field: 'Observaciones', id: 'observaciones' },
      { field: 'Fecha Fin Definitiva', id: 'fecha_fin_definitiva' },
      { field: 'Area Responsable', id: 'area_responsable' },
      { field: 'Nota de Venta', id: 'nombre_nota_venta' },
      { field: 'Situciación Baja', id: 'nombre_situcion_baja' },
      { field: 'Motivo de Baja', id: 'motiname' },
      { field: 'Tipo de Baja', id: 'nombre_tipo_baja' },
      { field: 'Plataforma', id: 'plataforma' },
      { field: 'Motivo de Anulación', id: 'motivo_anula' },
      { field: 'Mandante', id: 'mandante' },
      { field: 'Descripción Anulación', id: 'descripcion_anulacion' },
      { field: 'Tramo Baja', id: 'tramo_baja_comercial' },
      { field: 'Propietario', id: 'propietario' },
      { field: 'Ejecutivo', id: 'ejecutivo' },
      { field: 'Estado Conecta', id: 'estado_conecta' },
      { field: 'Razón Estado CRM', id: 'razon_estado' },
      { field: 'Glosa CRM', id: 'glosa_api_crm' },
      { field: 'Estado CRM', id: 'estado_crm' },
    ];

    return cols.map((col) => {
      let cellRenderer = null;
      if (col.id === 'estado_conecta') {
        cellRenderer = {
          cellRenderer: (params: any) =>
            this.iconState({ state: params.data.estado_conecta }),
        };
      }

      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
        ...cellRenderer,
      };
    });
  }

  iconState({ state }: IdParams): string {
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      state === 'Finalizado' ? 'rgb(42 255 78)' : 'rgb(255 58 58)'
    }"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${
        state || 'Pendiente'
      }</a>`;
  }
  handleClick() {
    this.dialogConfirmacionClose = true;
  }

  async mounted() {
    this.loadingService.showLoading();
    try {
      await this.getTramos();
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self = this;
    self.gridApi.setRowData(this.dataList);
    self.gridApi.setDomLayout('autoHeight');
    /*this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        const objectApi = { ...self.objParam, ...params.request };

        await fetchBajasComerciales({ body: { ...objectApi } })
          .then((resp) => {
            const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA, TOTAL } =
              resp.data;

            if (+CODIGO_RESPUESTA !== 1 || MENSAJE_RESPUESTA) {
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              throw new Error(MENSAJE_RESPUESTA);
            }
            self.dataList = LISTA;

            params.successCallback(LISTA, TOTAL);
          })
          .catch((err: Error) => {
            if (
              err instanceof Error &&
              err.message &&
              err.message !== 'Network Error'
            ) {
              self.$snotify.error(err.message);
              return;
            }
            self.$snotify.error(
              'Ha ocurrido un error inesperado, por favor intente más tarde'
            );
          });
      },
    };*/
    //this.reloadGrid();
  }

  validateTramoType(tramo: unknown): tramo is Tramo[] {
    return (
      Boolean(tramo) &&
      Array.isArray(tramo) &&
      tramo.every((item) => item instanceof Object && 'nombre_tramo' in item)
    );
  }

  validateDataMasivaType(data: unknown): data is DataMasiva[] {
    // Verificar si data es un array y cada elemento es un objeto con las propiedades requeridas
    return (
        Array.isArray(data) &&
        data.every((item) =>
            typeof item === 'object' &&
            item !== null &&
            'id' in item &&
            'NombreBaja' in item &&
            'CantEquipos' in item &&
            'CantPerifericos' in item &&
            'NombreTramoBajaComercial' in item
        )
    );
  }

  async getTramos() {
    try {
      const { data } = await fetchBajasComerciales({ endpoint: 'get_tramos' });

      if (+data.CODIGO_RESPUESTA !== 1) {
        throw new Error(data.MENSAJE_RESPUESTA);
      }
      // Valido que los datos de tramos sean de tipo Tramo[]
      if (this.validateTramoType(data.tramos)) {
        this.tramos = data.tramos;
      }
    } catch (error) {
      if (error instanceof Error && error.message && error.message !== 'Network Error') {
        this.$snotify.error(error.message);
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
      );
    }
  }

  async reloadGrid() {
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal();
    }
  }

  closeModal() {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('cerrar');
  }

  handleUpdate() {
    if (!this.dataList.length) {
      this.$snotify.error('No hay datos disponibles');
      return;
    }
    if (!Object.values(this.tramo).length) {
      this.$snotify.error('Debe Seleccionar un tramo');
      return;
    }
    this.getReportBajas();
  }

  async getReportBajas() {
    this.loadingService.showLoading();
    const user = localStorage.getItem('clienteDefecto');
    const user_id = JSON.parse(localStorage.getItem("user")).id;
    let listaBajas = this.dataList.map( x => x.nombre_baja);
    const body = {
      ...this.objParam,
      tramo: this.tramo,
      user,
      user_id,
      listaBajas: listaBajas,
    };

    try {
      const { data } = await fetchBajasComerciales({ endpoint: "get_bajas_report", body });
      if (+data.CODIGO_RESPUESTA !== 1) {
        throw new Error(data.MENSAJE_RESPUESTA);
      }
      this.msgReport = data.MENSAJE_RESPUESTA;
      this.showPopUpReport = true;
    } catch (error) {
      if (error instanceof Error && error.message && error.message !== 'Network Error') {
        this.$snotify.error(error.message);

      } else {
        this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
      );
      }
      this.loadingService.hideLoading();
    } finally {
      this.loadingService.hideLoading();
    }
  }

  handleCloseReport() {
    this.msgReport = '';
    this.showPopUpReport = false;
    this.closeModal();
  }
}
